import { render } from "./LanguageAwareEditor.vue?vue&type=template&id=3dcde610&scoped=true"
import script from "./LanguageAwareEditor.vue?vue&type=script&lang=js"
export * from "./LanguageAwareEditor.vue?vue&type=script&lang=js"

import "./LanguageAwareEditor.vue?vue&type=style&index=0&id=3dcde610&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dcde610"]])

export default __exports__